import React, { PureComponent } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Checkbox } from '@material-ui/core';
import _ from 'lodash';
import { contentManagementAction } from '../../../reducers/contentMangementData';
import ExpandToggleButton from './ExpandToggleButton';
import createStyles from '@material-ui/styles/createStyles';
import withStyles from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { getChapterNumber, isLastChapter } from '../helper';
import TestComponent from './TestComponent';
const styles = (theme: Theme) =>
  createStyles({
    dragArea: {
      position: 'relative',
      '&>:first-child': {
        padding: '0 0 0 15px!important',
      },
    },
    handleDragIcon: {
      position: 'absolute',
      top: 3,
      left: 0,
    },
    checkBoxElement: {
      padding: '0px 7px',
      top: 0,
      width: 20,
      height: 20,
      '-moz-appearance': 'none',
      opacity: 1,
      color: 'rgb(204, 204, 204)',
      border: '1px solid #B2B2B2',
      borderRadius: 2,
      margin: '-4px 14px 0px 16px',
      '& svg': {
        fontSize: '1.5rem',
        fontFamily: '"Nunito", sans-serif',
        fill: '#979797',
        opacity: 0,
      },
      '& span:nth-child(1)': {
        width: 24,
        zIndex: 9
    }
    },
    checkedCheckbox: {
      backgroundColor: '#1d7dea!important',
      border: '1px solid #1d7dea !important',
      borderRadius: 2,
      color: '#99a1a7',
      '&::after': {
        content: "''",
        fontSize: 14,
        position: 'absolute',
        top: 1,
        left: 6,
        width: 4,
        height: 10,
        border: 'solid #fff',
        borderWidth: '0 2px 2px 0',
        transform: 'rotate(45deg)',
      },
      '&:hover': {
        backgroundColor: '#1d7dea',
      },
    },
  });
interface ChapterPhaseProps {
  chapterPhaseData: any;
  setBulkDrag: Function;
  bulkDrag: any;
  handleExpandNode: Function;
  isExpanded: boolean;
  classes: any;
  treeData: any;
  subjectTab: string;
}
const grid = 5;
interface ChapterPhaseStates {
  bulkDrag: any;
  isDragEnabled: boolean;
  isChecked: boolean;
}
class ChapterPhase extends PureComponent<ChapterPhaseProps, ChapterPhaseStates> {
  constructor(props: ChapterPhaseProps) {
    super(props);
    this.state = {
      bulkDrag: {},
      isDragEnabled: false,
      isChecked: false,
    };
  }
  getItemStyle = (isDragging: any, draggableStyle: any) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: isDragging ? 'lightgrey' : 'white',

    // styles we need to apply on draggables
    ...draggableStyle,
  });
  handleOnChangeCheckBox = (event: any, key: string) => {
    const { bulkDrag, setBulkDrag,treeData,chapterPhaseData } = this.props;
    let cloneBulkDrag = JSON.parse(JSON.stringify(bulkDrag));
    const {
      name = '',
      subjectIndex,
      chapterIndex,
      phaseIndex,
      weekIndex,
      subjectName
    } = chapterPhaseData;
    if (!event.target.checked) {
      const chapterConcepts = treeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex].concepts;
       for(let i=0; i<chapterConcepts.length; i++){
        const newKey = `concept-${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}-${i}`;
         delete cloneBulkDrag[newKey];
       }
      delete cloneBulkDrag[key];
    }else{
      cloneBulkDrag = {
        ...cloneBulkDrag,
       [key]: event.target.checked,
      };
    }
    setBulkDrag({
      bulkDrag: { ...cloneBulkDrag },
    });
    if (event.target.checked) {
      this.setState({ isChecked: true });
      this.enableDrag();
    } else {
      this.setState({ isChecked: false });
      this.disableDrag();
    }
  };


  enableDrag = () => {
    this.setState({ isDragEnabled: true });
  };
  disableDrag = () => {
    this.setState({ isDragEnabled: false });
  };

  componentWillUnmount() {
    if (this.props.isExpanded) {
      this.props.handleExpandNode();
    }
  }

  render = () => {
    const { chapterPhaseData, bulkDrag, handleExpandNode, isExpanded, classes, treeData, subjectTab } = this.props;
    const {
      name = '',
      subjectIndex,
      chapterIndex,
      phaseIndex,
      weekIndex,
      subjectName,
      concepts,
      isBulkDataAdded,
    } = chapterPhaseData;
    const hasValidChildren = concepts && concepts.length;
    const {displaySettings} = treeData;
    const currentWeek = treeData.phases[phaseIndex].weeks[weekIndex];
    return (
      <span>
        <Droppable
        droppableId={
          bulkDrag[`chapter-${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}`]
            ? `chapter-bulk-${phaseIndex}-${weekIndex}`
            : `chapter-${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}`
        }
      >
        {(provided) => (
          <div ref={provided.innerRef} className={classes.dragArea}>
            <Draggable
              key={
                bulkDrag[`chapter-${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}`]
                  ? `chapter-bulk-${phaseIndex}-${weekIndex}`
                  : `chapter-${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}`
              }
              draggableId={
                bulkDrag[`chapter-${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}`]
                  ? `chapter-bulk-${phaseIndex}-${weekIndex}`
                  : `chapter-${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}`
              }
              index={chapterIndex}
            >
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  style={this.getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                  onMouseEnter={() => {
                    if (!this.state.isChecked) {
                      this.enableDrag();
                    }
                  }}
                  onMouseLeave={() => {
                    if (!this.state.isChecked) {
                      this.disableDrag();
                    }
                  }}
                >
                  {/* {this.state.isDragEnabled && (
                    <span {...provided.dragHandleProps} className={classes.handleDragIcon}>
                      <img src='/assets/img/course/make_sequence.png' alt='drag-icon' />
                    </span>
                  )} */}

                  <span
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      paddingLeft: '2px',
                      alignItems: 'center',
                    }}
                  >
                    <span style={{ flexBasis: '50%', display: 'flex' }}>
                      {hasValidChildren ? (
                        <ExpandToggleButton
                          handleClick={() => handleExpandNode()}
                          isExpanded={isExpanded}
                          isBulkDataAdded={isBulkDataAdded}
                        />
                      ) : (
                        <></>
                      )}
                      <span style={{ fontSize: '18px', color: '#333', marginLeft: '5px' }}>
                        {/* CH{getChapterNumber(this.props.subjectTab, this.props.chapterPhaseData, this.props.treeData)}.  */}
                        {name} &nbsp;
                        <span style={{ fontSize: '14px', color: '#666' }}>({subjectName})</span>
                      </span>
                    </span>
                    {displaySettings.showConcepts ? <span style={{ fontSize: '14px', color: '#666' }}>{`${concepts.length} Concepts`}</span>: ''}
                    <Checkbox
                      classes={{ root: classes.checkBoxElement, checked: classes.checkedCheckbox }}
                      color='primary'
                      checked={bulkDrag[`chapter-${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}`]}
                      onChange={(e: any) =>
                        this.handleOnChangeCheckBox(
                          e,
                          `chapter-${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}`
                        )
                      }
                    />
                  </span>
                </div>
              )}
            </Draggable>
            {provided.placeholder}
          </div>
        )}
        </Droppable>
        {/* render main tests */}
        {/* {isLastChapter(treeData, chapterPhaseData, subjectTab) && currentWeek.content.length ? (
          currentWeek.content.map((test: any, index: number) =>
            (<TestComponent test={test} phase={currentWeek} testIndex={index} testType={'week'} />)
          )
        ) :
          <></>
        } */}
      </span>
    );
  };
}

const mapStateToProps = (state: any) => ({
  bulkDrag: _.get(state, 'courseMangementData.contentManagementData.bulkDrag', {}),
  treeData: _.get(state, 'courseMangementData.contentManagementData.treeData', {}),
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setBulkDrag: contentManagementAction.setBulkDrag,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(ChapterPhase));
